import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7172740b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"flex-grow":"1"} }
const _hoisted_2 = { class: "ap-page-title-section section-part" }
const _hoisted_3 = { class: "ap-page-actions" }
const _hoisted_4 = {
  key: 0,
  class: "ap-page-tabs ap-btn-group section-part"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "fs-heading ap-page-title",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-title')))
      }, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header-action", {}, undefined, true)
      ])
    ]),
    (_ctx.headerTabs || _ctx.hasHeaderTabsSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header-tabs", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}